import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ErrorGenericSchema, GenericTimelyAccountId, OKGeneric } from '../models';
import { TimelyWebhookHeadersSchema } from '../models/models.sync';

const c = initContract();

export const TimelyAccountEventToTicBodySchema = z.object({
  event: z.enum(['account_entitlements_updated']),
  timely_account: z.object({
    id: GenericTimelyAccountId,
    features: z.object({ tic_integrations: z.boolean() }),
  }),
});

/** Internal-only: account-scoped Timely events that carry no user. */
export const internalApiSync = c.router({
  timelyAccountEventToTic: {
    method: 'POST',
    path: '/1.0/sync/timely-account-event-to-tic',
    headers: TimelyWebhookHeadersSchema,
    body: TimelyAccountEventToTicBodySchema,
    responses: { 200: OKGeneric, 202: OKGeneric, 500: ErrorGenericSchema },
    summary: 'Apply an account-scoped Timely event (plan entitlements)',
    description:
      "Internal app only. Requires INTERNAL_TIMELY_WEBHOOK_API_KEY. Timely sends `account_entitlements_updated` with the account's current entitlements whenever its plan or subscription status changes. `tic_integrations: false` queues a background disconnect of the account's connections and returns 202; `true` and unknown accounts return 200 with no action. Never mounted on the public API.",
  },
});
